import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useVoterAuth } from '../contexts/VoterAuthContext';
import client from '../api/client';

export default function VoterDashboard() {
  const { voter, logout } = useVoterAuth();
  const navigate = useNavigate();
  const [voterInfo, setVoterInfo] = useState(null);
  const [electionStatus, setElectionStatus] = useState(null);

  useEffect(() => {
    const cached = localStorage.getItem('election_status');
    if (cached) {
      setElectionStatus(cached);
    } else {
      client.get('/election/public').then(res => {
        setElectionStatus(res.data.status);
        localStorage.setItem('election_status', res.data.status);
      }).catch(() => {});
    }

    client.get('/voter/me').then(res => {
      setVoterInfo(res.data);
    }).catch(() => {});
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/vote/login');
  };

  if (!voter) {
    navigate('/vote/login');
    return null;
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Voter Dashboard</h1>
        <button onClick={handleLogout} className="btn-secondary">Logout</button>
      </div>

      <div className="card">
        <h2>Welcome, {voterInfo?.name || voter.name}</h2>
        <p>National ID: {voter.national_id}</p>
        {voterInfo && <p>Constituency: {voterInfo.constituency_name}</p>}
      </div>

      <div className="card">
        <h2>Election Status</h2>
        {electionStatus === 'open' ? (
          <div>
            <p className="status-open">Election is OPEN</p>
            {voterInfo?.has_voted ? (
              <p>You have already cast your vote.</p>
            ) : (
              <Link to="/vote/cast" className="btn-primary">Cast Your Vote</Link>
            )}
          </div>
        ) : electionStatus === 'closed' ? (
          <div>
            <p className="status-closed">Election is CLOSED</p>
            <p>The election has ended. Results are being tabulated.</p>
          </div>
        ) : (
          <p className="status-pending">Election has not started yet.</p>
        )}
      </div>

      <div className="card">
        <h2>Voting History</h2>
        <Link to="/vote/history" className="btn-secondary">View History</Link>
      </div>
    </div>
  );
}
